import { find, windowOrder } from "../calculations";
import { pixels } from "../../projects/CreateNewProject";
import { useReactToPrint } from "react-to-print";
import { useRef } from "react";
import YurtSVG from "../../../YurtSVG"

const WindowOrder = ({ yurtTrait, walls }) => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  let windows = find(walls, "windows");
  let sorted = windowOrder(windows);
  return (
    <>
      <div className="window-order mt-5" ref={componentRef}>
      <YurtSVG width="2rem"/>
      <h1>{yurtTrait.kitName} | <small>Window Order</small></h1>
      
      
        <table className="table">
          <thead>
            <tr>
              <th>Amount</th>
              <th>Size</th>
              <th>Type</th>
              <th>Tempered</th>
              <th>Outline</th>
            </tr>
          </thead>
          <tbody>
            {sorted.map((window, index) =>
              !window.amount ? null : (
                <tr key={index}>
                  <td>{window.amount}</td>
                  <td>
                    {window.w / pixels} x {window.h / pixels}
                  </td>
                  <td>{window.type}</td>
                  <td>{window.tempered === "STANDARD" ? "NO" : window.tempered}</td>
                  <td>
                    <div
                      style={{
                        border: "3px solid lightgrey",
                        width: window.w / pixels / 2 + "px",
                        height: window.h / pixels / 2 + "px",
                        background:
                          window.tempered === "TEMPERED"
                            ? "rgba(25, 25, 25, .05)"
                            : "transparent",
                        boxShadow: "6px 6px 7px 0px rgba(0, 0, 0, 0.05)",
                      }}
                    ></div>
                  </td>
                </tr>
              )
            )}
          </tbody>
        </table>
      </div>
      <button className="float-right" onClick={handlePrint}>
        Save
      </button>
    </>
  );
};

export default WindowOrder;
